import { useIntl } from 'react-intl'
import '../styles/index.scss'
// import {EmailPreferencesInput} from '../core/_constants'
// import { EmailPreferencesInputType, EmailPreferencesOutputType } from '../core/_models'
import { EmailPreferencesOutputType } from '../core/_models'
import { Dispatch, SetStateAction, useState } from 'react'
import { createEmailPreferences, getEmailPreferences } from '../core/_requests'
import { useAuth } from '../../auth'
import { toast } from 'react-toastify'
import { BasicButton } from '../../widgets/components/UI/BasicButton'
// import Skeleton from 'react-loading-skeleton'
// import '../../profile/styles/index.scss'
import '../../data-rooms/styles/DataRooms.scss'
// import { EmailPreference } from '../core/_constants'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
// import brandingConfig from '../../../../config/brandingConfig'
import { useThemeMode } from '../../../../_metronic/partials'

export const NotificationPreferences = ({
  key,
  getPreferences,
  getPreferencesApiLoading,
  setGetPreferences,
}: {
  key: number
  getPreferences: any
  getPreferencesApiLoading: boolean
  setGetPreferences: Dispatch<SetStateAction<EmailPreferencesOutputType[]>>
}) => {
  const [loading, setLoading] = useState(false)

  // const [isChecked, setIsChecked] = useState(false)
  const { companyId, currentUser } = useAuth()

  const handleToogle = (id: number, checked: boolean) => {
    getPreferences.map((preference: EmailPreferencesOutputType) => {
      if (preference.id === id) {
        return (preference.value = checked)
      }
      return null
    })
  }

  const handleSumbit = async () => {
    try {
      setLoading(true)
      if (companyId) {
        const {
          data: { success, errors },
        } = await createEmailPreferences(JSON.stringify(getPreferences), companyId)
        if (success) {
          const {
            data: {
              data: { preference },
              success,
            },
          } = await getEmailPreferences(companyId)
          if (success) {
            setGetPreferences(JSON.parse(preference))
          }
          setLoading(false)
          toast.success(formatMessage({ id: 'Preferences updated successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CreateEmailPreferencesSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                preference: JSON.parse(preference),
              },
            },
          })
        } else {
          setLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CreateEmailPreferencesFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CreateEmailPreferencesFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    }
  }

  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  const [selectedSidebarId, setSelectedSidebarId] = useState(1)
  const generalSidebarOptions = [
    { tabTitle: formatMessage({ id: 'RecordsKeeper.AI' }), id: 1 },
    { tabTitle: formatMessage({ id: 'Cap Table' }), id: 2 },
    { tabTitle: formatMessage({ id: 'Stakeholder' }), id: 3 },
    { tabTitle: formatMessage({ id: 'Shared Access' }), id: 4 },
    { tabTitle: formatMessage({ id: 'Payments' }), id: 5 },
    { tabTitle: formatMessage({ id: 'Others' }), id: 6 },
  ]
  // const EmailPreferencesInput = [
  //   {
  //     id: EmailPreference.NEW_INVESTOR_UPDATE,
  //     title: formatMessage({ id: 'New Investor Update is created' }),
  //     subtitle: formatMessage({
  //       id: `You will receive a notification if any of your team members created an investor update to the company profile on ${brandingConfig.brandName}.`,
  //     }),
  //     toggleLabel: 'newInvestorUpdateIsCreated',
  //   },
  //   {
  //     id: EmailPreference.PITCH_DECK_UPLOADED,
  //     title: formatMessage({ id: 'Pitch Deck Uploaded' }),
  //     subtitle: formatMessage({
  //       id: `You will receive a notification If any of your team members upload a pitch deck to the company profile on ${brandingConfig.brandName}.`,
  //     }),
  //     toggleLabel: 'pitchDeckUploaded',
  //   },
  //   {
  //     id: EmailPreference.INVESTOR_UPDATE_VIEWED,
  //     title: formatMessage({ id: 'Someone viewed your investor Update' }),
  //     subtitle: formatMessage({
  //       id: 'You will receive a notification if an investor views the investor update you sent',
  //     }),
  //     toggleLabel: 'someoneViewedYourInvestorUpdate',
  //   },
  //   {
  //     id: EmailPreference.UPCOMING_ACTIVITY,
  //     title: formatMessage({ id: 'Upcoming Scheduled Activity' }),
  //     subtitle: formatMessage({
  //       id: 'You will receive a notification if your team members add new activity with the investor.',
  //     }),
  //     toggleLabel: 'upcommingScheduledActivity',
  //   },
  //   {
  //     id: EmailPreference.NEW_TEAM_MEMBER,
  //     title: formatMessage({ id: 'New team Member added to the company' }),
  //     subtitle: formatMessage({
  //       id: `You will receive a notification if any of your current team members invite an external person to your company profile on ${brandingConfig.brandName}.`,
  //     }),
  //     toggleLabel: 'newTeamMemberAddedToTheCompany',
  //   },
  //   {
  //     id: EmailPreference.EMAIL_NOTIFICATION,
  //     title: formatMessage({ id: 'Email Notification' }),
  //     subtitle: formatMessage({
  //       id: 'You will receive a notification when any team member sends an email to investors.',
  //     }),
  //     toggleLabel: 'emailNotification',
  //   },
  //   {
  //     id: EmailPreference.DATAROOM_VIEWED,
  //     title: formatMessage({ id: 'Someone Viewed your DataRoom' }),
  //     subtitle: formatMessage({
  //       id: `You will receive a notification if any team members or investors have viewed your company's DataRoom.`,
  //     }),
  //     toggleLabel: 'someoneViewedYourDataRoom',
  //   },
  //   {
  //     id: EmailPreference.INVESTOR_CONFIRMED,
  //     title: formatMessage({ id: 'Investor Marked as Confirmed' }),
  //     subtitle: formatMessage({
  //       id: 'You will receive a notification if any team members mark an investor as confirmed for the current round.',
  //     }),
  //     toggleLabel: 'investorMarkedAsConfirmed',
  //   },
  //   {
  //     id: EmailPreference.INVESTOR_REJECTED,
  //     title: formatMessage({ id: 'Investor Marked as Rejected' }),
  //     subtitle: formatMessage({
  //       id: 'You will receive a notification if any team members mark an investor as rejected for the current round.',
  //     }),
  //     toggleLabel: 'investorMarkedAsRejected',
  //   },
  // ]

  // interface TooltipObj {
  //   [key: number]: string
  // }
  // const tooltipObj: TooltipObj = {
  //   1: 'Turn it on if you want to get notified when a new Investor Update is created by your team',
  //   2: 'Turn it on if you want receive notification when a new pitch deck has been added to the portal by your team',
  //   3: 'Turn it on to get notified when an investor has viewed the Investor Update shared by you',
  //   4: 'Turn it on to get notification when your team has added a new event or activity with the investor like a meeting',
  //   5: 'Turn it on to get notified when a new team member has been added to your company',
  //   6: 'Turn it on and get notified when an email has been shared with the investor(s) by your team',
  //   7: 'Turn it on to get notified when someone (a team member or any investor) views your Data Room',
  //   8: 'Turn it on to receive notification when an investor is marked as confirmed for the current round being raised',
  //   9: 'Turn it on to receive notification when an investor is marked as rejected for the current round being raised',
  // }

  // const toggleOptions = {
  //   recordsKeeperAI: {
  //     header: 'RecordsKeeper.AI Notifications',
  //     options: {
  //       1: {
  //         id: 1,
  //         title: 'New file has been uploaded',
  //         subHeading: 'You will receive notification when new files are uploaded to your storage.'
  //       },
  //       2: {
  //         id: 2,
  //         title: 'New cloud storage is connected',
  //         subHeading: 'You will be notified when new storage systems are connected to your account.'
  //       },
  //       3: {
  //         id: 3,
  //         title: 'New department or function is created',
  //         subHeading: 'You will be notified when new departments or functions are added for records classification.'
  //       },
  //       4: {
  //         id: 4,
  //         title: 'New document category is created',
  //         subHeading: 'You will be alerted when new document categories are created for records classification.'
  //       },
  //       5: {
  //         id: 5,
  //         title: 'New time period is defined to classification',
  //         subHeading: 'You will receive notification about new time period classifications for documents.'
  //       }
  //     },
  //   },
  //   capTable: {
  //     header: 'Cap table Managements Notifications',
  //     options: {
  //       1: {
  //         id: 1,
  //         title: 'New scenarios is created for Cap Table',
  //         subHeading: 'You will receive updates when new cap table scenarios are created.'
  //       },
  //       2: {
  //         id: 2,
  //         title: 'Investor is updated/created under Cap Table Scenario',
  //         subHeading: 'You will be notified of investor updates or additions in cap table scenarios.'
  //       },
  //     },
  //   },
  //   stakeholder: {
  //     header: 'Stakeholders Managements Notifications',
  //     options: {
  //       1: {
  //         id: 1,
  //         title: 'New individual shareholder/investor is added',
  //         subHeading: 'You will receive notification when individual shareholders or investors are added'
  //       },
  //       2: {
  //         id: 2,
  //         title: 'New institutional shareholder/investor is added',
  //         subHeading: 'You will get alerts when institutional shareholders or investors join.'
  //       },
  //       3: {
  //         id: 3,
  //         title: 'New Board Member is added',
  //         subHeading: 'You will receive notifications when a new board member is added.'
  //       },
  //       4: {
  //         id: 4,
  //         title: 'New Founder and Promoter is added',
  //         subHeading: 'New Founder and Promoter is added'
  //       },
  //       5: {
  //         id: 5,
  //         title: 'New team member is added under Management Team',
  //         subHeading: 'You will be notified when an new management team member is added.'
  //       },
  //       6: {
  //         id: 6,
  //         title: 'New team member is added under Legal & Compliance',
  //         subHeading: 'You will be notified when a new legal & compliance team member is added.'
  //       },
  //       7: {
  //         id: 7,
  //         title: 'New team member is added under Finance and Accounts',
  //         subHeading: 'You will be notified when a new finance and accounts team member is added.'
  //       },
  //       8: {
  //         id: 8,
  //         title: 'New team member is added under Advisors & Mentors',
  //         subHeading: 'You will receive updates when a new advisor & mentor is added.'
  //       },
  //     },
  //   },
  //   sharedAccess: {
  //     header: 'Shared Access Notifications',
  //     options: {
  //       1: {
  //         id: 1,
  //         title: 'New account is connected for inbox under Shared Access',
  //         subHeading: 'You will get alerts when new email accounts are connected for inbox monitoring.'
  //       },
  //       2: {
  //         id: 2,
  //         title: 'New event is added in your calendar',
  //         subHeading: 'You will be updated about new events added to your calendar.'
  //       },
  //     },
  //   },
  //   payments: {
  //     header: 'Payment Notifications',
  //     options: {
  //       1: {
  //         id: 1,
  //         title: 'Successful payments',
  //         subHeading: 'Receive a notification for every initiated payout.'
  //       },
  //       2: {
  //         id: 2,
  //         title: 'Billing Updates',
  //         subHeading: 'Receive a notification for update in billing and plan.'
  //       },
  //     },
  //   },
  //   others: {
  //     header: 'Others Notifications',
  //     options: {
  //       1: {
  //         id: 1,
  //         title: 'New team members',
  //         subHeading: 'Receive a notification for every initiated payout.'
  //       },
  //       2: {
  //         id: 2,
  //         title: 'Newsletters',
  //         subHeading: 'Receive a notification for every initiated payout.'
  //       },
  //       3: {
  //         id: 3,
  //         title: 'Successful payments',
  //         subHeading: 'Receive a notification for every initiated payout.'
  //       },
  //     },
  //   },
  // }

  const notifications = [
    {
      category: 'recordsKeeperAI',
      header: 'RecordsKeeper.AI Notifications',
      options: [
        {
          id: 1,
          title: 'New file has been uploaded',
          subHeading: 'You will receive notification when new files are uploaded to your storage.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 2,
          title: 'New cloud storage is connected',
          subHeading: 'You will be notified when new storage systems are connected to your account.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 3,
          title: 'New department or function is created',
          subHeading: 'You will be notified when new departments or functions are added for records classification.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 4,
          title: 'New document category is created',
          subHeading: 'You will be alerted when new document categories are created for records classification.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 5,
          title: 'New time period is defined to classification',
          subHeading: 'You will receive notification about new time period classifications for documents.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
      ],
    },
    {
      category: 'capTable',
      header: 'Cap table Managements Notifications',
      options: [
        {
          id: 1,
          title: 'New scenarios is created for Cap Table',
          subHeading: 'You will receive updates when new cap table scenarios are created.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 2,
          title: 'Investor is updated/created under Cap Table Scenario',
          subHeading: 'You will be notified of investor updates or additions in cap table scenarios.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
      ],
    },
    {
      category: 'stakeholder',
      header: 'Stakeholders Managements Notifications',
      options: [
        {
          id: 1,
          title: 'New individual shareholder/investor is added',
          subHeading: 'You will receive notification when individual shareholders or investors are added',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 2,
          title: 'New institutional shareholder/investor is added',
          subHeading: 'You will get alerts when institutional shareholders or investors join.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 3,
          title: 'New Board Member is added',
          subHeading: 'You will receive notifications when a new board member is added.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 4,
          title: 'New Founder and Promoter is added',
          subHeading: 'New Founder and Promoter is added',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 5,
          title: 'New team member is added under Management Team',
          subHeading: 'You will be notified when an new management team member is added.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 6,
          title: 'New team member is added under Legal & Compliance',
          subHeading: 'You will be notified when a new legal & compliance team member is added.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 7,
          title: 'New team member is added under Finance and Accounts',
          subHeading: 'You will be notified when a new finance and accounts team member is added.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 8,
          title: 'New team member is added under Advisors & Mentors',
          subHeading: 'You will receive updates when a new advisor & mentor is added.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
      ],
    },
    {
      category: 'sharedAccess',
      header: 'Shared Access Notifications',
      options: [
        {
          id: 1,
          title: 'New account is connected for inbox under Shared Access',
          subHeading: 'You will get alerts when new email accounts are connected for inbox monitoring.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 2,
          title: 'New event is added in your calendar',
          subHeading: 'You will be updated about new events added to your calendar.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
      ],
    },
    {
      category: 'payments',
      header: 'Payment Notifications',
      options: [
        {
          id: 1,
          title: 'Successful payments',
          subHeading: 'Receive a notification for every initiated payout.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 2,
          title: 'Billing Updates',
          subHeading: 'Receive a notification for update in billing and plan.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
      ],
    },
    {
      category: 'others',
      header: 'Others Notifications',
      options: [
        {
          id: 1,
          title: 'New team members',
          subHeading: 'Receive a notification for every initiated payout.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 2,
          title: 'Newsletters',
          subHeading: 'Receive a notification for every initiated payout.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
        {
          id: 3,
          title: 'Successful payments',
          subHeading: 'Receive a notification for every initiated payout.',
          tooltip: formatMessage({ id: 'tooltip' })
        },
      ],
    },
  ];



  return (
    // <>
    //   <div className='company-container p-6'>
    //     {getPreferencesApiLoading ? (
    //       <>
    //         <div className='w-100'>
    //           <div className='mb-10'>
    //             <Skeleton
    //               width={250}
    //               height={30}
    //               baseColor='var(--kt-skeleton-bg-color)'
    //               highlightColor='var(--kt-skeleton-highlight-bg-color)'
    //             />{' '}
    //           </div>
    //           {Array(9)
    //             .fill(null)
    //             .map((_, index) => (
    //               <>
    //                 <div className='d-flex gap-4 mt-8' key={index}>
    //                   <div>
    //                     <Skeleton
    //                       width={50}
    //                       height={30}
    //                       baseColor='var(--kt-skeleton-bg-color)'
    //                       highlightColor='var(--kt-skeleton-highlight-bg-color)'
    //                     />{' '}
    //                   </div>
    //                   <div className='w-100'>
    //                     <div className='w-md-25 w-50'>
    //                       <Skeleton
    //                         height={20}
    //                         baseColor='var(--kt-skeleton-bg-color)'
    //                         highlightColor='var(--kt-skeleton-highlight-bg-color)'
    //                       />{' '}
    //                     </div>
    //                     <div className='mt-2'>
    //                       <Skeleton
    //                         height={15}
    //                         baseColor='var(--kt-skeleton-bg-color)'
    //                         highlightColor='var(--kt-skeleton-highlight-bg-color)'
    //                       />{' '}
    //                     </div>
    //                   </div>
    //                 </div>
    //               </>
    //             ))}
    //           <div className='w-100 d-md-flex justify-content-md-end gap-4 align-items-md-end h-md-200px'>
    //             <div className='w-md-25 me-md-20 mt-8'>
    //               <Skeleton
    //                 height={40}
    //                 baseColor='var(--kt-skeleton-bg-color)'
    //                 highlightColor='var(--kt-skeleton-highlight-bg-color)'
    //               />{' '}
    //             </div>
    //           </div>
    //         </div>
    //       </>
    //     ) : (
    //       <>
    //         <div className='fs-6 fw-semibold pb-5'>
    //           {formatMessage({ id: 'Notification Preferences' })}
    //         </div>

    //         {EmailPreferencesInput.map(
    //           ({ id, title, subtitle }: EmailPreferencesInputType, index: number) => (
    //             <div className='border-bottom' key={id}>
    //               <form className='form-check form-check-custom form-check-solid form-check-primary form-switch pb-3 pt-3'>
    //                 {/* <input
    //                   className='form-check-input'
    //                   type='checkbox'
    //                   id={id.toString()}
    //                   name='model.app.sidebar.default.minimize.desktop.hoverable'
    //                   defaultChecked={getPreferences && getPreferences[index]?.value}
    //                   onChange={(e) => {
    //                     handleToogle(id, e.target.checked)
    //                   }}
    //                 /> */}
    //                 <label className='togglebtn'>
    //                   <input
    //                     className='togglebtn__input'
    //                     name='model.app.sidebar.default.minimize.desktop.hoverable'
    //                     defaultChecked={getPreferences && getPreferences[index]?.value}
    //                     type='checkbox'
    //                     id={id.toString()}
    //                     onChange={(e) => {
    //                       handleToogle(id, e.target.checked)
    //                     }}
    //                   />{' '}
    //                   <div className='togglebtn__fill'></div>
    //                 </label>
    //                 <div className='d-flex flex-column justify-content-end mt-2'>
    //                   <div className='d-flex'>
    //                     <div>
    //                       <label
    //                         className='form-check-label fw-semibold font-size-13 title-notification'
    //                         htmlFor={id.toString()}
    //                         data-bs-toggle='tooltip'
    //                         data-kt-initialized='1'
    //                       >
    //                         {formatMessage({ id: title })}
    //                       </label>
    //                     </div>
    //                     <div>{<ToolTipUI tooltipText={formatMessage({ id: tooltipObj[id] })} />}</div>
    //                   </div>
    //                   <label
    //                     className='form-check-label text-clr58 fw-normal fs-7'
    //                     htmlFor={id.toString()}
    //                     data-bs-toggle='tooltip'
    //                     data-kt-initialized='1'
    //                   >
    //                     {formatMessage({ id: subtitle })}
    //                   </label>
    //                 </div>
    //               </form>
    //             </div>
    //           )
    //         )}
    //         <div className='d-md-flex justify-content-md-end w-md-auto w-100 button-margin pb-md-8 me-md-8 me-0 pt-4 pt-md-auto'>
    //           <BasicButton
    //             buttonText={formatMessage({ id: 'Save Changes' })}
    //             onClick={handleSumbit}
    //             disabled={loading}
    //             loading={loading}
    //             height='44px'
    //             border='1px solid #4776E6'
    //             color='#4776E6'
    //             textColor='white'
    //             padding='12px 24px'
    //             customClass='w-md-auto w-100'
    //           />
    //         </div>
    //       </>
    //     )}
    //   </div>
    // </>
    <>
      <div className='d-flex flex-md-row flex-column'>
        <div className='mb-9 sidebar-investor-db col-md-1 d-none d-md-flex ' style={{ width: '14%' }}>
          {generalSidebarOptions.map((sideTab: any) => (
            <ul className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer '>
              <li
                className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${selectedSidebarId === sideTab.id
                  ? '  border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
                  : ''
                  }`}
                onClick={() => setSelectedSidebarId(sideTab.id)}
              >
                {formatMessage({ id: sideTab.tabTitle })}
              </li>
            </ul>
          ))}
        </div>

        <div className='mb-2 sidebar-investor-db col-md-1 d-flex d-md-none' style={{ width: '100%' }}>
          <div
            className='d-md-none d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {generalSidebarOptions.map((sideTab: any) => (
              <ul
                key={sideTab.id}
                className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 flex-nowrap mobile-tab-both my-md-0 mb-2 d-md-none'
                style={{ display: 'flex', flexWrap: 'nowrap' }}
              >
                <li
                  className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${selectedSidebarId === sideTab.id
                    ? 'border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                    : ''
                    }`}
                  onClick={() => setSelectedSidebarId(sideTab.id)}
                >
                  {formatMessage({ id: sideTab.tabTitle })}
                </li>
              </ul>
            ))}
          </div>
        </div>

        <div
          className={`d-flex flex-column p-md-6 p-6 mb-9 rounded-2 w-100  ${mode !== 'dark' ? 'bg-white' : ''}`}
          style={{ background: '#1e1e2d' }}
        >
          {selectedSidebarId === 1 &&
            <>
              {notifications
                .filter(({ category }) => category === 'recordsKeeperAI')
                .map(({ category, header, options }) => (
                  <div className='d-flex flex-column' key={category}>
                    <h3 className='font-size-16 fw-semibold' >{header}</h3>
                    {options.map(({ id, title, subHeading, tooltip }, index) => (
                      <div className="border-bottom" key={id}>
                        <form className="form-check form-check-custom form-check-solid form-check-primary form-switch pb-3 pt-3">
                          <label className="togglebtn ms-0">
                            <input
                              className="togglebtn__input"
                              name="model.app.sidebar.default.minimize.desktop.hoverable"
                              defaultChecked={getPreferences && getPreferences[index]?.value}
                              type="checkbox"
                              id={id.toString()}
                              onChange={(e) => {
                                handleToogle(id, e.target.checked);
                              }}
                            />
                            <div className="togglebtn__fill"></div>
                          </label>
                          <div className="d-flex flex-column justify-content-end mt-2">
                            <div className="d-flex">
                              <div>
                                <label
                                  className="form-check-label fw-semibold font-size-13 title-notification"
                                  htmlFor={id.toString()}
                                  data-bs-toggle="tooltip"
                                  data-kt-initialized="1"
                                >
                                  {formatMessage({ id: title })}
                                </label>
                              </div>
                            </div>
                            <label
                              className="form-check-label text-clr58 fw-normal fs-7"
                              htmlFor={id.toString()}
                              data-bs-toggle="tooltip"
                              data-kt-initialized="1"
                            >
                              {formatMessage({ id: subHeading })}
                            </label>
                          </div>
                        </form>
                      </div>
                    ))}
                  </div>
                ))}
            </>
          }
          {selectedSidebarId === 2 && <>
            {notifications
              .filter(({ category }) => category === 'capTable')
              .map(({ category, header, options }) => (
                <div className='d-flex flex-column' key={category}>
                  <h3 className='font-size-16 fw-semibold'>{header}</h3>
                  {options.map(({ id, title, subHeading, tooltip }, index) => (
                    <div className="border-bottom" key={id}>
                      <form className="form-check form-check-custom form-check-solid form-check-primary form-switch pb-3 pt-3">
                        <label className="togglebtn ms-0">
                          <input
                            className="togglebtn__input"
                            name="model.app.sidebar.default.minimize.desktop.hoverable"
                            defaultChecked={getPreferences && getPreferences[index]?.value}
                            type="checkbox"
                            id={id.toString()}
                            onChange={(e) => {
                              handleToogle(id, e.target.checked);
                            }}
                          />
                          <div className="togglebtn__fill"></div>
                        </label>
                        <div className="d-flex flex-column justify-content-end mt-2">
                          <div className="d-flex">
                            <div>
                              <label
                                className="form-check-label fw-semibold font-size-13 title-notification"
                                htmlFor={id.toString()}
                                data-bs-toggle="tooltip"
                                data-kt-initialized="1"
                              >
                                {formatMessage({ id: title })}
                              </label>
                            </div>
                          </div>
                          <label
                            className="form-check-label text-clr58 fw-normal fs-7"
                            htmlFor={id.toString()}
                            data-bs-toggle="tooltip"
                            data-kt-initialized="1"
                          >
                            {formatMessage({ id: subHeading })}
                          </label>
                        </div>
                      </form>
                    </div>
                  ))}
                </div>
              ))}
          </>}
          {selectedSidebarId === 3 && <>
            {notifications
              .filter(({ category }) => category === 'stakeholder')
              .map(({ category, header, options }) => (
                <div className='d-flex flex-column' key={category}>
                  <h3 className='font-size-16 fw-semibold'>{header}</h3>
                  {options.map(({ id, title, subHeading, tooltip }, index) => (
                    <div className="border-bottom" key={id}>
                      <form className="form-check form-check-custom form-check-solid form-check-primary form-switch pb-3 pt-3">
                        <label className="togglebtn ms-0">
                          <input
                            className="togglebtn__input"
                            name="model.app.sidebar.default.minimize.desktop.hoverable"
                            defaultChecked={getPreferences && getPreferences[index]?.value}
                            type="checkbox"
                            id={id.toString()}
                            onChange={(e) => {
                              handleToogle(id, e.target.checked);
                            }}
                          />
                          <div className="togglebtn__fill"></div>
                        </label>
                        <div className="d-flex flex-column justify-content-end mt-2">
                          <div className="d-flex">
                            <div>
                              <label
                                className="form-check-label fw-semibold font-size-13 title-notification"
                                htmlFor={id.toString()}
                                data-bs-toggle="tooltip"
                                data-kt-initialized="1"
                              >
                                {formatMessage({ id: title })}
                              </label>
                            </div>
                          </div>
                          <label
                            className="form-check-label text-clr58 fw-normal fs-7"
                            htmlFor={id.toString()}
                            data-bs-toggle="tooltip"
                            data-kt-initialized="1"
                          >
                            {formatMessage({ id: subHeading })}
                          </label>
                        </div>
                      </form>
                    </div>
                  ))}
                </div>
              ))}
          </>}
          {selectedSidebarId === 4 && <>
            {notifications
              .filter(({ category }) => category === 'sharedAccess')
              .map(({ category, header, options }) => (
                <div className='d-flex flex-column' key={category}>
                  <h3 className='font-size-16 fw-semibold'>{header}</h3>
                  {options.map(({ id, title, subHeading, tooltip }, index) => (
                    <div className="border-bottom" key={id}>
                      <form className="form-check form-check-custom form-check-solid form-check-primary form-switch pb-3 pt-3">
                        <label className="togglebtn ms-0">
                          <input
                            className="togglebtn__input"
                            name="model.app.sidebar.default.minimize.desktop.hoverable"
                            defaultChecked={getPreferences && getPreferences[index]?.value}
                            type="checkbox"
                            id={id.toString()}
                            onChange={(e) => {
                              handleToogle(id, e.target.checked);
                            }}
                          />
                          <div className="togglebtn__fill"></div>
                        </label>
                        <div className="d-flex flex-column justify-content-end mt-2">
                          <div className="d-flex">
                            <div>
                              <label
                                className="form-check-label fw-semibold font-size-13 title-notification"
                                htmlFor={id.toString()}
                                data-bs-toggle="tooltip"
                                data-kt-initialized="1"
                              >
                                {formatMessage({ id: title })}
                              </label>
                            </div>
                          </div>
                          <label
                            className="form-check-label text-clr58 fw-normal fs-7"
                            htmlFor={id.toString()}
                            data-bs-toggle="tooltip"
                            data-kt-initialized="1"
                          >
                            {formatMessage({ id: subHeading })}
                          </label>
                        </div>
                      </form>
                    </div>
                  ))}
                </div>
              ))}
          </>}
          {selectedSidebarId === 5 && <>
            {notifications
              .filter(({ category }) => category === 'payments')
              .map(({ category, header, options }) => (
                <div className='d-flex flex-column' key={category}>
                  <h3 className='font-size-16 fw-semibold'>{header}</h3>
                  {options.map(({ id, title, subHeading, tooltip }, index) => (
                    <div className="border-bottom" key={id}>
                      <form className="form-check form-check-custom form-check-solid form-check-primary form-switch pb-3 pt-3">
                        <label className="togglebtn ms-0">
                          <input
                            className="togglebtn__input"
                            name="model.app.sidebar.default.minimize.desktop.hoverable"
                            defaultChecked={getPreferences && getPreferences[index]?.value}
                            type="checkbox"
                            id={id.toString()}
                            onChange={(e) => {
                              handleToogle(id, e.target.checked);
                            }}
                          />
                          <div className="togglebtn__fill"></div>
                        </label>
                        <div className="d-flex flex-column justify-content-end mt-2">
                          <div className="d-flex">
                            <div>
                              <label
                                className="form-check-label fw-semibold font-size-13 title-notification"
                                htmlFor={id.toString()}
                                data-bs-toggle="tooltip"
                                data-kt-initialized="1"
                              >
                                {formatMessage({ id: title })}
                              </label>
                            </div>
                          </div>
                          <label
                            className="form-check-label text-clr58 fw-normal fs-7"
                            htmlFor={id.toString()}
                            data-bs-toggle="tooltip"
                            data-kt-initialized="1"
                          >
                            {formatMessage({ id: subHeading })}
                          </label>
                        </div>
                      </form>
                    </div>
                  ))}
                </div>
              ))}
          </>}
          {selectedSidebarId === 6 && <>
            {notifications
              .filter(({ category }) => category === 'others')
              .map(({ category, header, options }) => (
                <div className='d-flex flex-column' key={category}>
                  <h3 className='font-size-16 fw-semibold'>{header}</h3>
                  {options.map(({ id, title, subHeading, tooltip }, index) => (
                    <div className="border-bottom" key={id}>
                      <form className="form-check form-check-custom form-check-solid form-check-primary form-switch pb-3 pt-3">
                        <label className="togglebtn ms-0">
                          <input
                            className="togglebtn__input"
                            name="model.app.sidebar.default.minimize.desktop.hoverable"
                            defaultChecked={getPreferences && getPreferences[index]?.value}
                            type="checkbox"
                            id={id.toString()}
                            onChange={(e) => {
                              handleToogle(id, e.target.checked);
                            }}
                          />
                          <div className="togglebtn__fill"></div>
                        </label>
                        <div className="d-flex flex-column justify-content-end mt-2">
                          <div className="d-flex">
                            <div>
                              <label
                                className="form-check-label fw-semibold font-size-13 title-notification"
                                htmlFor={id.toString()}
                                data-bs-toggle="tooltip"
                                data-kt-initialized="1"
                              >
                                {formatMessage({ id: title })}
                              </label>
                            </div>
                          </div>
                          <label
                            className="form-check-label text-clr58 fw-normal fs-7"
                            htmlFor={id.toString()}
                            data-bs-toggle="tooltip"
                            data-kt-initialized="1"
                          >
                            {formatMessage({ id: subHeading })}
                          </label>
                        </div>
                      </form>
                    </div>
                  ))}
                </div>
              ))}
          </>}
          <div className='d-md-flex justify-content-md-end w-md-auto w-100 button-margin me-md-8 me-0 pt-4 pt-md-auto'>
            <BasicButton
              buttonText={formatMessage({ id: 'Save Changes' })}
              onClick={handleSumbit}
              disabled={loading}
              loading={loading}
              height='44px'
              border='1px solid #4776E6'
              color='#4776E6'
              textColor='white'
              padding='12px 24px'
              customClass='w-md-auto w-100'
            />
          </div>
        </div>
      </div>
    </>
  )
}
